import { useCallback, useMemo } from 'react'

export interface Notification {
  id: string
  title: string
  body: string
  createdAt: string  // ISO timestamp
  read: boolean
  icon?: string      // bi-* icon name
  link?: string      // optional in-app route to navigate on click
}

/**
 * Notifications hook — UI-side shell.
 *
 * The backend list endpoint doesn't exist yet (only POST /tracking/notify
 * which triggers sends, not lists). When it does, swap the empty array
 * below for a React Query call, and route mark-read through the API.
 *
 * The hook shape (notifications, unreadCount, markRead, markAllRead) is
 * deliberately stable so the only thing that changes is the data source.
 */
export function useNotifications() {
  // TODO: replace with `useQuery(['notifications'], () => api.listNotifications())`
  const notifications = useMemo<Notification[]>(() => [], [])

  const unreadCount = useMemo(
    () => notifications.filter(n => !n.read).length,
    [notifications]
  )

  const markRead = useCallback((_id: string) => {
    // TODO: POST /notifications/:id/read
  }, [])

  const markAllRead = useCallback(() => {
    // TODO: POST /notifications/read-all
  }, [])

  return { notifications, unreadCount, markRead, markAllRead }
}
